import React from 'react';
import IpaffsModalDetailedView from './IpaffsModalDetailedView';
import IpaffsModalDetailedViewReadOnly from './IpaffsModalDetailedViewReadOnly';

const IpaffsModalTabDetailedView = ({ readOnly = false, data = [] }) => {
  return <>{!readOnly ? <IpaffsModalDetailedView /> : <IpaffsModalDetailedViewReadOnly data={data} />}</>;
};

export default IpaffsModalTabDetailedView;
